/**
 * Program Entry Point
 */
export { DEFAULT_MESSAGE } from './constants';
export { create } from './js-rpc';
//# sourceMappingURL=index.js.map